import React, { useCallback, useEffect, useRef, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Box, Button, Card, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material'
import { getFromStorage } from '../../utils/storage'
import { api } from '../../utils/api'
import { handleError } from '../../utils/error'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { currentUserActions } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { mainGreen } from '../../utils/color'

export default function CreateAuthorization() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [actions, setActions] = useState([])
	const [actionCheck, setActionCheck] = useState([])
	const [actionVN, setActionVN] = useState([])
	const positionRef = useRef(null)
	const descRef = useRef(null)

	const getActions = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_ACTIONS_ADMIN,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setActions(response.data)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, navigate, dispatch],
	)

	useEffect(() => {
		getActions()
	}, [getActions])

	const handleChange = (e) => {
		let { value, checked } = e.target
		if (checked === true) {
			setActionCheck([...actionCheck, value])
			actions.forEach((action) => {
				if (action.name === value) {
					setActionVN([...actionVN, action.desc])
				}
			})
		} else {
			actions.forEach((action) => {
				if (action.name === value) {
					setActionVN(actionVN?.filter((actionVN) => actionVN !== action.desc))
				}
			})
			setActionCheck(actionCheck?.filter((action) => action !== value))
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		const name = positionRef.current.value
		const desc = descRef.current.value
		if (name.trim() === '' || desc.trim() === '') {
			alert('Vui lòng nhập đầy đủ thông tin')
			return
		}
		try {
			const response = await axios({
				url: api.POST_ROLE_ADMIN,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				method: 'POST',
				data: {
					name,
					permission: actionCheck,
					permissionVN: actionVN,
					description: desc,
				},
				withCredentials: true,
			})
			alert(response.data.message)
			navigate('/admin/roles')
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Box maxWidth='sm' sx={{ margin: '0 auto' }}>
				<Card sx={{ padding: '10px' }}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}>
						<Box component='form' onSubmit={handleSubmit} noValidate>
							<TextField
								inputRef={positionRef}
								sx={{ background: '#fff' }}
								margin='normal'
								fullWidth
								id='name'
								label='Vị trí'
								name='name'
								autoComplete='name'
								autoFocus
							/>
							<TextField
								inputRef={descRef}
								sx={{ background: '#fff' }}
								margin='normal'
								fullWidth
								id='name'
								label='Mô tả'
								name='name'
								autoComplete='name'
								autoFocus
							/>
							<Typography sx={{ fontWeight: 'bold', mt: 3, mb: 1 }}>Quyền hạn</Typography>

							{actions?.map((action, index) => {
								return (
									<FormControlLabel
										key={index}
										control={<Checkbox value={action.name} onChange={handleChange} />}
										label={action.desc}
									/>
								)
							})}
							<Button
								type='submit'
								fullWidth
								variant='contained'
								sx={{
									mt: 3,
									mb: 2,
									background: mainGreen,
									'&:hover': { background: mainGreen },
								}}>
								Tạo phân quyền
							</Button>
						</Box>
					</Box>
				</Card>
			</Box>
		</UserLayout>
	)
}
